module.exports = __webpack_public_path__ + "static/img_2196-9a93259d553916b7c33805918f57ab88.webp";